import { styled } from '@mui/material/styles';

export const StyledHeader = styled('div')(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['xs'])};
  margin-bottom: ${theme.DS_spacing(['sm'])};
  ${theme.breakpoints.up('lg')} { 
    margin-top: ${theme.DS_spacing(['xs'])};
   }
`,
);

export const StyledSpan = styled('span')(
  ({ theme }) => `
  padding-right: ${theme.DS_spacing(['xxs'])};
`,
);

export const StyledServiceNameWrapper = styled('div')(
  ({ theme }) => `
  p {
    margin: ${theme.DS_spacing(['sm'])} 0 ${theme.DS_spacing(['xxs'])};
  }
`,
);

export const StyledLocationDate = styled('div')(
  ({ theme }) => `

    margin-top: ${theme.DS_spacing(['sm'])};
  
`,
);
